<template>
  <div class="page-editor">
    <mt-header fixed title="修改企业信息">
      <router-link to="/index/profile" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <mt-field label="企业名称" placeholder="请输入企业名称" v-model="entInfo.name" readonly></mt-field>
    <mt-field label="法定代表人" placeholder="请输入法定代表人" v-model="entInfo.legalMan" class="required"></mt-field>
    <mt-field label="住所" placeholder="请输入住所" v-model="entInfo.address" class="required" type="textarea" rows="3"></mt-field>
    <mt-field label="联系人" placeholder="请输入联系人" v-model="entInfo.linkman" class="required"></mt-field>
    <mt-field label="联系电话" placeholder="请输入联系电话" v-model="entInfo.telephone" class="required"></mt-field>
    <mt-field label="电子邮箱" placeholder="请输入电子邮箱" v-model="entInfo.email"></mt-field>
    <mt-field label="网站地址" placeholder="请输入网站地址" v-model="entInfo.website"></mt-field>
    <mt-field label="经营范围" placeholder="请输入经营范围" v-model="entInfo.busScope" type="textarea" class="required" rows="5"></mt-field>
    <upload-field label="营业执照" :required="true" v-model="entInfo.certFileId"></upload-field>
    <upload-field label="荣誉资质" v-model="entInfo.honorFileId"></upload-field>
    <upload-field label="微信公众号" v-model="entInfo.wxmpImgId"></upload-field>

    <div class="page-btn">
      <mt-button type="primary" size="large" @click.native="saveEnt">提交</mt-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import "mint-ui/lib/style.css";
import { Toast, Cell, Button, Field, Header } from "mint-ui";
import UploadField from "./UploadField";
export default {
  components: {Header,Button,Cell,Field,UploadField},
  data() {
    return {
      entInfo: {}
    };
  },
  methods: {
    checkData() {
      return (
        this.entInfo &&
        this.entInfo.legalMan &&
        this.entInfo.address &&
        this.entInfo.linkman &&
        this.entInfo.telephone &&
        this.entInfo.certFileId &&
        this.entInfo.busScope
      );
    },
    saveEnt() {
      if(!this.checkData()){
        Toast("请完善必填项目！");
        return;
      }

      this.$http
        .post(this.GLOBAL.serverUrl + "/ent/update", this.entInfo)
        .then(resp => {
          if (resp.body.code == 200) {
            this.$router.push("/index/profile");
          } else if (resp.body.code == 500) {
            Toast("操作失败！");
          }
        });
    }
  },
  mounted() {
    this.$http.get(this.GLOBAL.serverUrl + "/ent/info").then(resp => {
      if (resp.body.code == 200) this.entInfo = resp.body.data;
      else if (resp.body.code == 500) Toast("获取数据失败，请稍后再试！");
    });
  }
};
</script>
<style scoped>
.page-editor {
  padding-top: 40px;
}
.mint-cell.is-textarea .mint-cell-title {
  padding: 0.5rem !important;
}
.page-btn {
  margin-top: 1rem;
  padding: 1rem;
}
</style>